import { createFileRoute } from "@tanstack/react-router";
import { ProductFieldsPage } from "@/components/planning/fields/ProductFieldsPage";

export const Route = createFileRoute("/_app/p/$productKey/fields")({ component: View });

function View() {
  const { productKey } = Route.useParams();
  return <ProductFieldsPage productKey={productKey} />;
}
